import { CreditType } from "../../../api/types.gen.js";
import { DEFAULT_CREDIT_API_ROOT } from "../../../config/api.js";
import { createAppSlice } from "../../../lib/store/createAppSlice.js";
import { name } from "../config/name.js";
const DEFAULT_CREDIT_PARAMS_FORMATTER = (_) => ({
  type: CreditType.ANNUITY,
  currency: "RUB",
  country: "RU",
  present_value: 0,
  tags: ""
});
const initialState = {
  clientId: "test-perxis-client",
  apiRoot: DEFAULT_CREDIT_API_ROOT,
  creditParamsFormatter: DEFAULT_CREDIT_PARAMS_FORMATTER
};
const slice = createAppSlice({
  name,
  initialState,
  reducers: {
    setApiRoot(state, action) {
      state.apiRoot = action.payload;
    },
    setClientId(state, action) {
      state.clientId = action.payload;
    },
    setCreditParamsFormatter(state, action) {
      state.creditParamsFormatter = action.payload;
    }
  }
});
const actions = {
  ...slice.actions
};
export {
  actions,
  slice
};
